import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.ComparisonTool = class ComparisonTool extends Snappy.BaseComponent {
    static get tagName() {
        return 'fa-comparison-tool';
    }

    constructor(element) {
        super(element);
    }

    setVars() {
        
    }
    equalHeight(){
        var titleHeight = $('.membership-table__title').height();
        $('.placeholder__content').css('height',titleHeight);
    }

    render() {
        this.equalHeight();
        $('.errorMessageWrapper').hide();
		
        var btnAddToCompare = $('.add-to-compare');
        $(btnAddToCompare).click(function(e) {
		
            var col = $(this).parent().data('col');
            var selectedItem = $('div[data-col=' + col + ']');
            var clonedItem =$('.slick-slide.slick-cloned .list-item');
			
            $(selectedItem).toggleClass('ticked selected');
            $(clonedItem).removeClass('ticked'); 
			
            //Display data for selected item/s
            var currentSelection = $('.membership-table.original div.membership-table__data[data-col=' + col + ']');
            $(currentSelection).toggle().toggleClass('current');    
            $(currentSelection).appendTo($(currentSelection).closest('.membership-table.original'));
			
			
            // Create a clone of the membership table headers (right next to original)
            $('.membership-table.cloned').remove();
            var cloneData = $('.membership-table.original').clone();
            $(cloneData).insertAfter('.membership-table.original')
						.addClass('cloned')
						.css({
						    'position':'fixed',
						    'z-index':'1'
						})
						.removeClass('original');
			
            var clonedTable = $('.membership-table.cloned');
            $(clonedTable).find('.membership-table__title').html('');//Display blank for cloned table
			
            var clonedTableData = $('.membership-table.cloned .membership-table__data');
            $(clonedTableData).find('.list-item').addClass('selected');
            $(clonedTableData).find('.availability-status, .price-details, ul').remove();
			
            //Sticky Item
            var scrollIntervalID = setInterval(stickItem, 10);
            function stickItem() {

                var orgElementPos = $('.original').offset();
                var orgElementTop = orgElementPos.top;               

                if ($(window).scrollTop() >= (orgElementTop)) {
                    // scrolled past the original position; now only show the cloned, sticky element.
                    // Cloned element should always have same left position and width as original element.     
                    var orgElement = $('.original');
                    var coordsOrgElement = orgElement.offset();
                    var leftOrgElement = coordsOrgElement.left;  
                    var widthOrgElement = orgElement.css('width');
                    if($( window ).width() >= 992){
                        $('.cloned').css('left',leftOrgElement+'px').css('top',25).css('width',widthOrgElement).show();
                        $('.fa-sub-navigation').css('display','none');
                    }else{
                        $('.cloned').css('left',leftOrgElement+'px').css('top',10).css('width',widthOrgElement).show();
                        $('.fa-sub-navigation').css('display','block');
                    }
                } else {
                    // not scrolled past the menu; only show the original menu.
                    $('.cloned').hide();
                    $('.fa-sub-navigation').css('display','block');
                }
            }
			
            var selectCount = $('div.list-item.ticked').length;
            console.log(selectCount);
			
            //Membership Carousel
            if($( window ).width() >= 768){
                if(selectCount == 3){
                    $('.list-item:not(".selected")').css({opacity: "0.65"});
                    $('.list-item:not(".selected") .add-to-compare').css({cursor: "default"});
                }else if(selectCount > 3){
                    $('.errorMessageWrapper').show();
					
                    var col = $(this).parent().data('col');
                    var currentItem = $('div[data-col=' + col + ']');
                    $(currentItem).removeClass('selected ticked');
                    $('.membership-table.original div.membership-table__data[data-col=' + col + ']').removeClass('current').hide();
                    $('.membership-table.cloned div.membership-table__data[data-col=' + col + ']').removeClass('current').hide();
					
                }else{
                    $('.list-item:not(".selected")').css({opacity: "1"});
                    $('.list-item:not(".selected") .add-to-compare').css({cursor: "pointer"});
                }
            }
			
            if($( window ).width() < 768){
                if(selectCount == 2){
                    $('.list-item:not(".selected")').css({opacity: "0.65"});
                    $('.list-item:not(".selected") .add-to-compare').css({cursor: "default"});
                }else if(selectCount > 2){
                    $('.errorMessageWrapper').show();
                    $('.errorMessageWrapper .errorMessage p').html('Please select a maximum of 2 memberships for comparison');					
                    var col = $(this).parent().data('col');
                    var currentItem = $('div[data-col=' + col + ']');
                    $(currentItem).removeClass('selected ticked');
                    $('.membership-table.original div.membership-table__data[data-col=' + col + ']').removeClass('current').hide();
                    $('.membership-table.cloned div.membership-table__data[data-col=' + col + ']').removeClass('current').hide();
					
                }else{
                    $('.list-item:not(".selected")').css({opacity: "1"});
                    $('.list-item:not(".selected") .add-to-compare').css({cursor: "pointer"});
                }
            }

        });
		
        $('.errorMessage').click(function(){
            $(this).parent().hide(); 
        }); 

        //Placeholder
        if($( window ).width() >= 768){
            $('.fa-comparison-tool .add-to-compare').click(function(){
                var selectedMembership = $('.membership-table.original .membership-table__data.selected.current').length;
                if(selectedMembership == 0){
                    $('.fa-comparison-tool .placeholder').show();
                }
                if(selectedMembership == 1){
                    $('.fa-comparison-tool .placeholder').hide();
                    $('.fa-comparison-tool .placeholder:lt(2)').show();
                }
                if(selectedMembership == 2){
                    $('.fa-comparison-tool .placeholder').hide();
                    $('.fa-comparison-tool .placeholder:lt(1)').show();
                }
                if(selectedMembership == 3){
                    $('.fa-comparison-tool .placeholder').hide();
                }
            });
        }
        if($( window ).width() < 768){
            $('.fa-comparison-tool .add-to-compare').click(function(){
                var selectedMembership = $('.membership-table.original .membership-table__data.selected.current').length;
                if(selectedMembership == 0){
                    $('.fa-comparison-tool .placeholder:lt(2)').show();
                }
                if(selectedMembership == 1){
                    $('.fa-comparison-tool .placeholder').hide();
                    $('.fa-comparison-tool .placeholder:lt(1)').show();
                }
                if(selectedMembership == 2){
                    $('.fa-comparison-tool .placeholder').hide();
                }
            });
        } 
        
        //Hide Sticky Nav
        var comparisonToolSection = $('.fa-comparison-tool').closest('section');
        var nextSection  = $(comparisonToolSection).next();
        var offsetNextSection = $(nextSection).offset();
        var offsetNextSectionTop = offsetNextSection.top;

        $(window).scroll(function() {
			
            var clonedTable = $('.membership-table.cloned');
			
            if ($(window).scrollTop() >= (offsetNextSectionTop) - ($(window).width() < 768 ? 300 : 550)) {
                $(clonedTable).find('.membership-table__data.ticked.selected.current').addClass('hiddenItem');
            }else {
                $(clonedTable).find('.membership-table__data.ticked.selected.current').removeClass('hiddenItem');
            }
			
        });

    }
}


// WEBPACK FOOTER //
// ./components/comparisonTool/scripts/comparisonTool.js